
export default function hoistReactInstance(getInstance, methods) {
	return function (Target) {
		if (typeof getInstance !== 'function' || typeof Target !== 'string' // don't hoist over string (html) components
		) {

				methods && [].concat(methods).forEach(function (method) {
					Target.prototype[method] = function () {
						var element = getInstance(this);
						if (element && element[method]) {
							return element[method].apply(element, arguments);
						}
					};
				});
			}

		return Target;
	};
}


//////////////////
// WEBPACK FOOTER
// ./~/hoist-react-instance-methods/es/index.js
// module id = 28
// module chunks = 0